import {Directive, ElementRef, EventEmitter, Inject, Optional, Output, SkipSelf} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ERROR_COLLECTOR_SOURCE, ErrorCollection} from '../../util/ErrorCollection';
import {VALIDATION_CONTEXT_REFLECTION} from '../context/validation-named-context-base.directive';
import {VALIDATION_CONTEXT_LOCAL} from '../context/validation-common-context.directive';
import {ValidationCheckBaseDirective, ValidationSubmitEvent} from './validation-check-base.directive';
import {ValidationContext} from '../../data/validation-context';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[onValidContinue],[onInvalidContinue],[onValidatedContinue]'
})
export class ValidationCheckContinueDirective extends ValidationCheckBaseDirective {
    protected static ngSubmitStub = new EventEmitter();

    constructor(
        $element: ElementRef,
        @Inject(ERROR_COLLECTOR_SOURCE) @SkipSelf() @Optional()
        $errorCollection: ErrorCollection,
        @Inject(VALIDATION_CONTEXT_REFLECTION) @SkipSelf() @Optional()
        $globalContext: ValidationContext,
        @Inject(VALIDATION_CONTEXT_LOCAL) @SkipSelf() @Optional()
        $localContext: ValidationContext,
        $ngForm: NgForm,
    ) {
        super($element, $errorCollection, $globalContext, $localContext, $ngForm);
    }

    protected performSubmit(): void {
        const previousSubmitState = this.ngForm.submitted;
        const originalSubmitEmitter = this.ngForm.ngSubmit;

        // Prevent form from dispatching submit event
        this.ngForm.ngSubmit = ValidationCheckContinueDirective.ngSubmitStub;
        // This submit is required to update all ngModels and validate form.
        this.ngForm.onSubmit(new CustomEvent('submit'));
        // Restore original event dispatcher.
        this.ngForm.ngSubmit = originalSubmitEmitter;

        // Restore previous submitted state if required
        if (previousSubmitState !== this.ngForm.submitted) {
            (this.ngForm as { submitted: boolean }).submitted = previousSubmitState;
        }

        // This is required to mark all fields as dirty (errors will be displayed in that case).
        ValidationCheckBaseDirective.markDirtyRecursively(this.ngForm.control);
    }

    @Output()
    public get onValidContinue(): EventEmitter<ValidationSubmitEvent> {
        return this.onValid$;
    }

    @Output()
    public get onInvalidContinue(): EventEmitter<ValidationSubmitEvent> {
        return this.onInvalid$;
    }

    @Output()
    public get onValidatedContinue(): EventEmitter<ValidationSubmitEvent> {
        return this.onValidated$;
    }
}
